import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';

import useDialog from 'hooks/useDialog';
import useExclusiveOffer from 'hooks/useExclusiveOffer';

import { sendEvent } from 'lib/gtag';
import { toOfferRedirectLink } from 'lib/links';
import placeholder from 'lib/placeholder';
import { getUtmsFromSession } from 'lib/sessionStorage';

const CouponDialog = dynamic(() => import('./CouponDialog'), {
  ssr: false,
});

const getUtmsAsSearchParam = () =>
  new URLSearchParams(getUtmsFromSession()).toString();

const GoToStoreButton = ({
  className,
  gaEventCategory,
  gaEventCategoryPostfix,
  isFinished,
  offerCoupon,
  offerId,
  offerUserVisibility,
}) => {
  const { showDialog } = useDialog();
  const { isOfferBlocked } = useExclusiveOffer();

  const utms = getUtmsAsSearchParam();

  if (offerCoupon && !isFinished) {
    return (
      <Button
        className={className}
        disabled={isOfferBlocked(offerUserVisibility)}
        size="size1"
        type="primary"
        full
        onClick={() => {
          sendEvent({
            action: 'modal_coupon_open',
            category: 'active_offer_buy',
          });
          showDialog(CouponDialog, {
            offerCoupon,
            offerId,
            utms,
            gaEventCategoryPostfix,
          });
        }}
      >
        {offerId === 1968763
          ? placeholder('actions.seeOffers')
          : placeholder('actions.goToStore')}
      </Button>
    );
  }

  return (
    <Button
      as="a"
      className={twJoin(
        isFinished && 'border-none bg-neutral-high-400 dark:bg-neutral-high-400'
      )}
      disabled={isOfferBlocked(offerUserVisibility)}
      href={toOfferRedirectLink(offerId, utms)}
      iconLeft={isFinished ? <Icon name="link-blank" /> : null}
      size="size1"
      type={isFinished ? 'neutral' : 'primary'}
      full
      onClick={() => {
        sendEvent({
          action: 'go_store',
          category: `${gaEventCategory}${
            gaEventCategoryPostfix ? `_${gaEventCategoryPostfix}` : ''
          }`,
        });
      }}
    >
      {isFinished
        ? placeholder('titles.finishedOffer')
        : placeholder('actions.goToStore')}
    </Button>
  );
};

GoToStoreButton.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  gaEventCategoryPostfix: PropTypes.string,
  isFinished: PropTypes.bool.isRequired,
  offerCoupon: PropTypes.string,
  offerId: PropTypes.number.isRequired,
  offerUserVisibility: PropTypes.string.isRequired,
};

export default GoToStoreButton;
